import { render, staticRenderFns } from "./showrealtime.vue?vue&type=template&id=320d97a4&scoped=true&"
import script from "./showrealtime.vue?vue&type=script&lang=js&"
export * from "./showrealtime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320d97a4",
  null
  
)

export default component.exports